import React from 'react';
import { useTranslation } from 'react-i18next';
import { CoreLink } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import Dossier from '../../../../components/Molecules/Dossier';
import type { TaxonomyDossier as Type } from '../../../../types/taxonomy';
import './style.scss';

interface DossierHighlightedProps {
  entity: ImmutableEntity<Type>;
}

const DossierHighlighted: React.FC<DossierHighlightedProps> = ({ entity }) => {
  const { t } = useTranslation();
  const name = entity.getIn(['name', 0, 'value'], '');
  const link = entity.getIn(['paths', 'nl']);

  return (
    <Dossier
      image={entity.getIn(['field_media_image', 0, 'styles', 'paragraph_image'])}
      // @ts-expect-error
      link={entity.getIn(['paths', 'nl'])}
    >
      {/* @ts-expect-error */}
      <div className="DossierHighlighted">
        <h3>{name}</h3>
        <CoreLink href={link}>
          {t('dossier.view_dossier')}
          <div className="icon icon-chevron-right" />
        </CoreLink>
      </div>
    </Dossier>
  );
};

export default DossierHighlighted;
